import Cookies from 'js-cookie'
//重构 token操作
const TokenKey = 'Admin-Token'
const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// export function getExpiresIn() {
//   return Cookies.get(ExpiresInKey) || -1
// }
//未找到被使用 ExpiresInKey

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}
//未找到被使用 ExpiresInKey
// export function removeExpiresIn() {
//   return Cookies.remove(ExpiresInKey)
// }
